export default "__VITE_ASSET__DEQZLmUD__"